(function (window, overwatch, MainMenu) {

    document.exitFullscreen = document.exitFullscreen || document.mozCancelFullscreen || document.webkitExitFullscreen || _.noop;


    window.Login = {
        open: function () {
            window.location = '?login';
        }
    };

    $(document).ready(function () {
        // TODO: Remove this hack
        // Override login link per page to allow for proper redirect after login.
        // This is a temporary workaround until https://jira.blizzard.com/browse/WMBLZ-1408
        $('.Navbar-accountDropdownButtonLink')
            .attr('href', '/login?redirect=' + window.location.href);
    });

    MainMenu.init({
        $menuMainWrap: $(".menu-main-wrap"),
        $menuMain: $(".menu-main"),
        $socialMenuMain: $(".menu-social.desktop-only"),
        $menuMainPin: $(".menu-main-wrap .menu-main-pin"),
        $buyButtonWrap: $(".erebos-button-container"),
        menuMainThreshold: 100,
        hiddenClass: "menu-hidden",
        fixedClass: "is-fixed"
    });

    $(document).on('webkitfullscreenchange mozfullscreenchange fullscreenchange', function () {
        var isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || null;
        $(document.body).toggleClass('is-fullscreen', isFullScreen);
    });

    //PROMO Video
    $('.promo-video-link').on('click', function (event) {
        var id = $(this).attr('data-yt-id');
        if (!overwatch.util.mobile() && !overwatch.util.touch()) {
            event.preventDefault();
            window.app.helpers.loadVideoIntoFrame(id);
        }
    });

    var navbarPrefix = 'Navbar';

    window.svg4everybody({
        polyfill: true,
    });

    $('input').placeholder();

    app.videoCustomLoop.init();
    app.videoPlayInView.init();
    app.youtubePlayer.init();

}(window, window.overwatch, window.MainMenu));
